import { notification } from 'antd';
import { $success } from '@components';
import { exportProduceScoreFailureCsv } from '@/utils/exportBatchFailureCsv';

/**
 * 从接口响应或异常中解析提交失败原因。
 * @param {*} res 接口响应。
 * @param {Error|*} error 异常对象。
 * @param {string} [fallback] 兜底文案。
 * @returns {string} 失败原因。
 */
export const resolveProduceScoreSubmitReason = (res, error, fallback = '未知错误') => {
    if (res?.msg) {
        return res.msg;
    }
    if (res?.message) {
        return res.message;
    }
    const data = error?.response?.data;
    if (data?.msg) {
        return data.msg;
    }
    if (data?.message) {
        return data.message;
    }
    if (error?.message) {
        return error.message;
    }
    return fallback;
};

/**
 * 单条打分结果提示。
 * @param {Object} result 提交结果。
 * @returns {void}
 */
export const notifySingleProduceScoreSubmit = (result) => {
    if (result.ok) {
        $success('提交成功');
        return;
    }
    notification.error({
        message: '提交失败',
        description: `原因为${result.reason || '未知错误'}`,
        duration: 8,
        style: { marginTop: '10vh' }
    });
};

/**
 * 批量打分失败明细下载按钮。
 * @param {Object} props 组件属性。
 * @param {Array} props.failures 失败记录。
 * @returns {JSX.Element}
 */
const FailureDownloadButton = ({ failures }) => (
    <div style={{ marginTop: 8 }}>
        <button
            type="button"
            className="amp-blue-btn cursor-pointer"
            onClick={() => exportProduceScoreFailureCsv(failures)}
        >
            查看失败原因（下载明细表格）
        </button>
    </div>
);

/**
 * 批量打分结果提示（全部成功 / 部分成功 / 全部失败）。
 * @param {Object} result 批量提交结果。
 * @returns {void}
 */
export const notifyBatchProduceScoreSubmit = (result) => {
    const { total, successCount, failCount, failures } = result;
    if (failCount === 0 && successCount > 0) {
        $success(`全部成功，共计${successCount}条`);
        return;
    }
    const failureLink = <FailureDownloadButton failures={failures} />;
    if (successCount === 0) {
        notification.error({
            message: '提交失败',
            description: (
                <div>
                    <div>
                        共
                        {total}
                        条均未提交成功。
                    </div>
                    {failureLink}
                </div>
            ),
            duration: 12,
            style: { marginTop: '10vh' }
        });
        return;
    }
    notification.warning({
        message: '部分提交成功',
        description: (
            <div>
                <div>
                    提交成功
                    {successCount}
                    条，失败
                    {failCount}
                    条
                </div>
                {failureLink}
            </div>
        ),
        duration: 12,
        style: { marginTop: '10vh' }
    });
};
